import React from 'react';
import { useIsMobile } from '@repo/common';
import LinkBanner from './Link/LinkBanner';
import LinkForm from './Link/LinkForm';
import StepTitle from '../Common/StepTitle';
import MobileLinkForm from './Link/MobileLinkForm';

const LinkStep = ({ resumeData, setResumeData }) => {
  const isMobile = useIsMobile();

  return (
    <div className='w-full flex flex-col items-start tabletH:pb-[30px]'>
      {isMobile && <LinkBanner $isMobile={isMobile} />}
      <StepTitle title='Link' $isMobile={isMobile} />
      <div className='w-full flex items-start'>
        <div className='w-full flex items-start'>
          <div className='flex-1 min-w-0 tabletH:pr-6'>
            {isMobile ? (
              <MobileLinkForm
                link={resumeData.link}
                setResumeData={setResumeData}
              />
            ) : (
              <LinkForm link={resumeData.link} setResumeData={setResumeData} />
            )}
          </div>
          {!isMobile && <LinkBanner />}
        </div>
      </div>
    </div>
  );
};

export default LinkStep;
